import {
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@frontend/ui'
import { Search } from 'lucide-react'

interface TeamStatsFilterBarProps {
  positionOptions: { value: string; label: string }[]
  position: string
  onPositionChange: (pos: string) => void

  partitionAllLabel: string
  partitionOptions: { id: string; name: string }[]
  partitionId: string
  onPartitionChange: (id: string) => void

  searchQuery: string
  onSearchChange: (q: string) => void
}

export function TeamStatsFilterBar({
  positionOptions,
  position,
  onPositionChange,
  partitionAllLabel,
  partitionOptions,
  partitionId,
  onPartitionChange,
  searchQuery,
  onSearchChange
}: TeamStatsFilterBarProps) {
  return (
    <div className='flex flex-wrap items-center gap-2'>
      <Select value={position} onValueChange={onPositionChange}>
        <SelectTrigger className='w-36'>
          <SelectValue placeholder='All positions' />
        </SelectTrigger>
        <SelectContent>
          {positionOptions.map((pos) => (
            <SelectItem key={pos.value || 'all'} value={pos.value || 'All'}>
              {pos.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {partitionOptions.length > 0 && (
        <Select value={partitionId} onValueChange={onPartitionChange}>
          {/* `w-auto` lets the trigger grow with the longest drill name
              instead of truncating (some drills are named things like
              "Possession — half-pitch" which clip at the old fixed 7rem). */}
          <SelectTrigger className='w-auto min-w-28'>
            <SelectValue placeholder={partitionAllLabel} />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value='all'>{partitionAllLabel}</SelectItem>
            {partitionOptions.map((p) => (
              <SelectItem key={p.id} value={p.id}>
                {p.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}

      <div className='relative ml-auto w-full max-w-[283px] sm:flex-1'>
        <Search className='text-muted-foreground absolute top-1/2 left-2.5 h-4 w-4 -translate-y-1/2' />
        <Input
          name='playerSearch'
          placeholder='Search Players'
          aria-label='Search players'
          value={searchQuery}
          onChange={onSearchChange}
          className='pl-9'
        />
      </div>
    </div>
  )
}
